import { Alert } from '@mui/material';
import { Error } from '@mui/icons-material';
import { CheckCircle } from '@mui/icons-material';
import { Warning } from '@mui/icons-material';
import { Info } from '@mui/icons-material';
import { FC } from 'react';

interface ExistingErrorProps {
  message: string;
  severity: 'error' | 'warning' | 'info' | 'success';
}

const ExistingError: FC<ExistingErrorProps> = ({ message, severity }) => {
  let icon;
  let textColor;

  switch (severity) {
    case 'error':
      icon = <Error sx={{ color: 'var(--error)' }} />;
      textColor = 'var(--error)';
      break;
    case 'warning':
      icon = <Warning sx={{ color: 'var(--warning)' }} />;
      textColor = 'var(--warning)';
      break;
    case 'info':
      icon = <Info sx={{ color: 'var(--info)' }} />;
      textColor = 'var(--info)';
      break;
    case 'success':
      icon = <CheckCircle sx={{ color: 'var(--success)' }} />;
      textColor = 'var(--success)';
      break;
  }

  return (
    <Alert
      severity={severity}
      icon={icon}
      sx={{
        width: '450px',
        mt: 2,
        mx: 'auto',
        fontFamily: 'Outfit',
        fontWeight: '400',
        fontSize: '14px',
        color: textColor,
      }}
    >
      {message}
    </Alert>
  );
};

export default ExistingError;
